import {
  Configuration,
  CompanyApiFactory,
  DriverApiFactory,
  VehicleApiFactory,
  FleetManagerApiFactory,
  TrailerApiFactory,
  GroupApiFactory,
  RoleApiFactory,
  TenantApiFactory,
  EldDeviceApiFactory,
  NotificationSubscriptionApiFactory,
  HosLogsApiFactory,
  LiveTrackTokenApiFactory,
  UnidentifiedEventsApiFactory,
  DiagnosticsApiFactory,
  EldDisconnectionApiFactory,
  DisconnectedDrivingApiFactory,
  VehicleMaintenanceApiFactory,
  EldMalfunctionsApiFactory,
  EventApiFactory,
  DvirFormApiFactory,
  DvirHistoryApiFactory,
  MasterEldDeviceApiFactory,
  LocationHistoryVehiclesApiFactory,
  TenantRegistrationApiFactory,
  MasterFleetManagerApiFactory,
  PublicApiClientApiFactory,
  SafetyAlertsApiFactory,
  TrailerTrackingProviderApiFactory,
  VehicleViewApiFactory,
  EldDeviceMessageApiFactory,
  RecentViolationApiFactory,
  DriverViewApiFactory,
  TenantEldDeviceViewApiFactory,
  FmcsaInspectionApiFactory,
  MasterEventApiFactory,
  EventViewApiFactory,
  MobileAppVersionApiFactory,
  FuelProviderApiFactory,
  TenantViewApiFactory,
  MasterEldDeviceUsageApiFactory,
  DemoAccountApiFactory,
  TripsViewApiFactory,
  CustomersEldDevicesApiFactory,
  VirtualTenantApiFactory,
  FlowApiClientApiFactory,
  EldFileExportApiFactory,
  EldFileImportApiFactory,
  MasterEldUsageReportArchiveApiFactory,
  ReportArchiveApiFactory,
  PublicApiRedirectionApiFactory,
  PublicApiRedirectionRequestApiFactory,
} from "./service-proxies";
import { AxiosInstance } from "axios";
import resourceNames from "./resourceNames";
import resourceToApiMap from "./resourceToApiMap";
import { IResourceMap } from "./types";
import { MockDataApiFactory } from "./mock-data/mockDataApiFactory";
import { MobileAppVersionApiFactoryAdapter } from "../../components/master/mobile-app-versions/MobileAppVersionApiFactoryAdapter";
import { DisconnectedDrivingApiFactoryAdapter } from "../../components/hos/disconnected-drivings/DisconnectedDrivingApiFactoryAdapter";

const apiInterfaces = {
  [resourceNames.ADMIN_COMPANIES]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => CompanyApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_DRIVERS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => DriverApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_DRIVERS_VIEW]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => DriverViewApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_VEHICLES]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => VehicleApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_VEHICLES_VIEW]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => VehicleViewApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_FLEET_MANAGERS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => FleetManagerApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_TRAILERS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => TrailerApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_TRAILER_GPS_PROVIDERS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => TrailerTrackingProviderApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_FUEL_PROVIDERS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => FuelProviderApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_GROUPS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => GroupApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_ROLES]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => RoleApiFactory(config, baseURL, axiosInstance),
  [resourceNames.MASTER_TENANTS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => TenantApiFactory(config, baseURL, axiosInstance),
  [resourceNames.MASTER_TENANTS_VIEW]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => TenantViewApiFactory(config, baseURL, axiosInstance),
  [resourceNames.MASTER_TENANT_REGISTRATIONS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => TenantRegistrationApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_ELDS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => EldDeviceApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_NOTIFICATIONS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => NotificationSubscriptionApiFactory(config, baseURL, axiosInstance),
  [resourceNames.LOCATIONS_LIVETRACK_TOKENS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => LiveTrackTokenApiFactory(config, baseURL, axiosInstance),
  [resourceNames.HOS_RECENT_VIOLATIONS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => RecentViolationApiFactory(config, baseURL, axiosInstance),
  [resourceNames.HOS_DRIVERS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => HosLogsApiFactory(config, baseURL, axiosInstance),
  [resourceNames.HOS_LOGS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => HosLogsApiFactory(config, baseURL, axiosInstance),
  [resourceNames.HOS_EVENTS_VIEW]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => EventViewApiFactory(config, baseURL, axiosInstance),
  [resourceNames.HOS_DRIVER_LOGS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => HosLogsApiFactory(config, baseURL, axiosInstance),
  [resourceNames.HOS_UNIDENTIFIED_DRIVING]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => UnidentifiedEventsApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ASSETS_MALFUNCTIONS_DIAG]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => DiagnosticsApiFactory(config, baseURL, axiosInstance),
  [resourceNames.HOS_ELD_DISCONNECTIONS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => EldDisconnectionApiFactory(config, baseURL, axiosInstance),
  [resourceNames.HOS_DISCONNECTED_DRIVINGS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) =>
    new Proxy(
      DisconnectedDrivingApiFactory(config, baseURL, axiosInstance),
      DisconnectedDrivingApiFactoryAdapter()
    ),
  [resourceNames.HOS_FMCSA_DATA_TRANSFER]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => FmcsaInspectionApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ASSETS_MAINTENANCE]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => VehicleMaintenanceApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ASSETS_VEHICLE_MAINTENANCE]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => VehicleMaintenanceApiFactory(config, baseURL, axiosInstance),
  [resourceNames.HOS_ELD_MALFUNCTIONS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => EldMalfunctionsApiFactory(config, baseURL, axiosInstance),
  [resourceNames.HOS_EVENTS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => EventApiFactory(config, baseURL, axiosInstance),
  [resourceNames.HOS_EVENTS_MASTER]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => MasterEventApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_DVIR_FORMS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => DvirFormApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ASSETS_DVIR_HISTORY]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => DvirHistoryApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ASSETS_DVIR_VEHICLE_HISTORY]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => DvirHistoryApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ASSETS_DVIR_VEHICLE_DEFECTS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => DvirHistoryApiFactory(config, baseURL, axiosInstance),
  [resourceNames.MASTER_ELDS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => MasterEldDeviceApiFactory(config, baseURL, axiosInstance),
  [resourceNames.MASTER_TENANT_ELDS_USAGE]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => MasterEldDeviceUsageApiFactory(config, baseURL, axiosInstance),
  [resourceNames.MASTER_TENANT_ELDS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => TenantEldDeviceViewApiFactory(config, baseURL, axiosInstance),
  [resourceNames.MASTER_TENANT_OWN_ELDS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => CustomersEldDevicesApiFactory(config, baseURL, axiosInstance),
  [resourceNames.LOCATIONS_HISTORY_VEHICLES]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => LocationHistoryVehiclesApiFactory(config, baseURL, axiosInstance),
  [resourceNames.LOCATIONS_STATE_TRIPS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => TripsViewApiFactory(config, baseURL, axiosInstance),
  [resourceNames.LOCATIONS_STATE_TRIPS_BY_STATE]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => TripsViewApiFactory(config, baseURL, axiosInstance),
  [resourceNames.LOCATIONS_STATE_TRIPS_BY_VEHICLE]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => TripsViewApiFactory(config, baseURL, axiosInstance),
  [resourceNames.MASTER_FLEET_MANAGERS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => MasterFleetManagerApiFactory(config, baseURL, axiosInstance),
  [resourceNames.MASTER_DEMO_ACCOUNTS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => DemoAccountApiFactory(config, baseURL, axiosInstance),
  [resourceNames.MASTER_VIRTUAL_TENANTS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => VirtualTenantApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_API_CLIENTS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => PublicApiClientApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_FLOW_API_CLIENTS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => FlowApiClientApiFactory(config, baseURL, axiosInstance),
  [resourceNames.SAFETY_ALERTS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => SafetyAlertsApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_ELD_MESSAGES]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => EldDeviceMessageApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_ELD_EXPORT]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => EldFileExportApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_ELD_IMPORT]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => EldFileImportApiFactory(config, baseURL, axiosInstance),
  [resourceNames.MASTER_ELD_USAGE_REPORT_ARCHIVE]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => MasterEldUsageReportArchiveApiFactory(config, baseURL, axiosInstance),
  [resourceNames.REPORTS_ARCHIVE]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => ReportArchiveApiFactory(config, baseURL, axiosInstance),
  [resourceNames.PUBLIC_API_REDIRECTION]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => PublicApiRedirectionApiFactory(config, baseURL, axiosInstance),
  [resourceNames.PUBLIC_API_REDIRECTION_REQUESTS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => PublicApiRedirectionRequestApiFactory(config, baseURL, axiosInstance),
  [resourceNames.ADMIN_MOBILE_APP_VERSIONS]: (
    baseURL: string,
    axiosInstance: AxiosInstance,
    config?: Configuration
  ) => {
    const factory = MobileAppVersionApiFactory(config, baseURL, axiosInstance);
    return new Proxy(
      factory,
      MobileAppVersionApiFactoryAdapter(config, baseURL, axiosInstance)
    );
  },
};

const apiResourceExists = (key: string) => {
  for (let k in resourceNames) {
    if (resourceNames[k as keyof typeof resourceNames] === key) {
      return true;
    }
  }

  return false;
};

export default (
  baseURL: string,
  axiosInstance: AxiosInstance
): IResourceMap => ({
  getApiResource: (key: string) => {
    if (!apiResourceExists(key)) {
      return null;
    }

    const apiRouteName = resourceToApiMap[key];
    if (!apiRouteName) {
      console.warn(`The API route name for resource '${key}' is not mapped!`);
    }

    if (apiInterfaces[key]) {
      return {
        apiRouteName: apiRouteName,
        api: (config?: Configuration) =>
          apiInterfaces[key](baseURL, axiosInstance, config),
      };
    }

    return {
      apiRouteName: apiRouteName,
      api: (config?: Configuration) => MockDataApiFactory(key),
      isMockResource: true,
    };
  },
});
